<template>
  <div>
    <div v-if="!firstDay && !lastDay" class="row">
      <div class="col">
        <h6 v-if="isEditable || hasExcursion" class="card-title mb-1">
          {{ title }}
        </h6>
        <button
          v-if="isEditable && hasExcursion"
          class="btn btn-sm btn-danger float-right mx-1"
          :aria-label="removeButtonCaption"
          @click="removeProduct(dayNumber, productType)"
        >
          {{ removeButtonCaption }}
        </button>
        <button
          v-if="isEditable && hasExcursion"
          class="btn btn-sm btn-warning float-right mx-1"
          :aria-label="changeButtonCaption"
          @click="selectProduct(dayNumber, productType)(dayNumber, productType)"
        >
          {{ changeButtonCaption }}
        </button>
        <button
          v-if="isEditable && !hasExcursion"
          class="btn btn-sm btn-info float-right mx-1"
          @click="selectProduct(dayNumber, productType)"
          :aria-label="addButtonCaption"
        >
          {{ addButtonCaption }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '../../main.js'

export default {
  props: {
    excursion: { type: Object, default: null },
    time: { type: String, default: '00:00' },
    dayNumber: { type: Number, requried: true },
    lastDay: { type: Boolean, required: true },
    readOnly: { type: Boolean, default: false }
  },
  data() {
    return {
      addButtonCaption: 'Add Evening Entertainment',
      changeButtonCaption: 'Change',
      removeButtonCaption: 'Remove'
    }
  },
  computed: {
    productType() {
      return 'Entertainment'
    },
    firstDay() {
      return this.dayNumber === 1
    },
    title() {
      if (this.excursion != null) {
        if (this.excursion.productType.productTypeCode === 'REST') {
          return 'Evening meal at ' + this.excursion.title + ' @ ' + this.time
        }
        return this.excursion.title
      }
      return 'Evening at your Hotel'
    },
    isEditable() {
      return !this.readOnly && !this.firstDay && !this.lastDay
    },
    hasExcursion() {
      return this.excursion != null
    }
  },
  methods: {
    selectProduct(dayNo, productType) {
      eventBus.selectProduct(dayNo, productType)
    },
    removeProduct(dayNo, productType) {
      this.$store.dispatch('removeProduct', { dayNo, productType })
    }
  }
}
</script>
